import type { HTMLAttributes, ReactNode } from "react";

export type BadgeVariant = "default" | "success" | "danger";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  children?: ReactNode;
}

export function Badge({
  variant = "default",
  className,
  children,
  ...rest
}: BadgeProps) {
  const classes = ["qr-badge"];
  if (variant !== "default") classes.push(`qr-badge-${variant}`);
  if (className) classes.push(className);

  return (
    <span className={classes.join(" ")} {...rest}>
      {children}
    </span>
  );
}
